import { render } from "./snsList.vue?vue&type=template&id=6b39ba05&scoped=true"
import script from "./snsList.vue?vue&type=script&lang=js"
export * from "./snsList.vue?vue&type=script&lang=js"

import "./snsList.vue?vue&type=style&index=0&id=6b39ba05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b39ba05"]])

export default __exports__